import { CircularProgress } from "@material-ui/core";
import React from 'react'

function Loading() {
    return (
        <div style={
            {
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                width: '100%',
                paddingTop: 100,
                paddingBottom: 100
            }}
        >
            <CircularProgress style={{ width: 100, height: 100 }} />
        </div>
    );
}

export default Loading